<template lang="pug">
#modal-header-planilha
    el-dialog.modal-header-planilha-content(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        width='50%'
    )
        span(slot='title')
            h3
                b {{ $t('mensagens.relatorioRastreabilidade.cadastro.informarRastreabilidadeMassa') }}

        .modal-header-planilha-content__container
            .container-header
                .container-header-table__infor(v-if='modalAlerta || show')
                    el-alert(
                        :title='alertDados.msg',
                        :type='alertDados.type',
                        show-icon,
                        :closable='false'
                    )

                div(v-if='temError')
                    .container-header-table
                        el-table(
                            ref='tabelaDadosProcessadosRef',
                            :data='dadosPaginado',
                            style='width: 100%'
                        )
                            el-table-column(
                                :label='$t("mensagens.relatorioRastreabilidade.cadastro.registro")'
                            )
                                template(slot-scope='scope') {{ (paginaAtual - 1) * pageCount + scope.$index + 1 }}

                            el-table-column(
                                :label='$t("mensagens.relatorioRastreabilidade.cadastro.linha")'
                            )
                                template(slot-scope='scope') {{ scope.row.linha }}

                            el-table-column(
                                :label='$t("mensagens.relatorioRastreabilidade.cadastro.campo")'
                            )
                                template(slot-scope='scope') {{ scope.row.campo }}

                            el-table-column(
                                :label='$t("mensagens.relatorioRastreabilidade.cadastro.erro")'
                            )
                                template(slot-scope='scope') {{ scope.row.mensagem }}

                    .container-header-pagination
                        .spans-paginacao

                        el-pagination(
                            background,
                            :page-size='pageCount',
                            :pager-count='pageCount',
                            :current-page.sync='paginaAtual',
                            layout='prev, pager, next',
                            :total='dados.length',
                            @current-change='mudarPagina'
                        )
                div(v-else)
                    .container-header-table
                        h4
                            b {{ $t('mensagens.relatorioRastreabilidade.cadastro.listaCarsImportados') }}

                        el-table(
                            ref='tabelaDadosProcessadosRef',
                            :data='dadosPaginado',
                            style='width: 100%'
                        )
                            el-table-column(label='CAR')
                                template(slot-scope='scope') {{ scope.row.CAR }}

                            el-table-column(label='CPF/CNPJ')
                                template(slot-scope='scope') {{ formatarCpfCnpj(scope.row['CPF/CNPJ']) }}

                            el-table-column(
                                :label='$t("mensagens.relatorioRastreabilidade.cadastro.volume")'
                            )
                                template(slot-scope='scope') {{ scope.row.Volume }}

                            el-table-column(
                                :label='$t("mensagens.relatorioRastreabilidade.cadastro.ciclo") + "/" + $t("mensagens.relatorioRastreabilidade.cadastro.ano")'
                            )
                                template(slot-scope='scope') {{ formatarAnoCiclo(scope.row['CICLO/ANO']) }}
                            template(slot='empty')
                                el-empty(
                                    :description='$t("mensagens.comuns.semDados")'
                                )

                    .container-header-pagination
                        .spans-paginacao
                            span.pagina
                                | {{ dados.length }} {{ dados.length > 1 ? $t('mensagens.relatorioRastreabilidade.cadastro.imoveis') : $t('mensagens.relatorioRastreabilidade.cadastro.imovel') }}

                            span.volume
                                | {{ formatarTonelada(somarTonelada) }} {{ somarTonelada === 1 ? $t('mensagens.relatorioRastreabilidade.cadastro.tonelada') : $t('mensagens.relatorioRastreabilidade.cadastro.toneladas') }}

                        el-pagination(
                            background,
                            :page-size='pageCount',
                            :pager-count='pageCount',
                            :current-page.sync='paginaAtual',
                            layout='prev, pager, next',
                            :total='dados.length',
                            @current-change='mudarPagina'
                        )

        footer.my-3(slot='footer')
            .btn-voltar
                el-button(
                    @click='fecharModal',
                    v-if='!temError',
                    :disabled='carregando'
                )
                    | {{ $t('mensagens.comuns.voltar') }}

            .btn-opcao
                div(v-if='temError')
                    el-button(type='primary', @click='fecharModal')
                        | {{ $t('mensagens.comuns.fechar') }}
                div(v-else)
                    el-button(
                        type='primary',
                        @click='analisarImoveis',
                        :loading='carregando',
                        :icon='carregando ? "el-icon-loading" : ""'
                    )
                        | {{ carregando ? '' : $t('mensagens.relatorioRastreabilidade.cadastro.analisarElegibilidade') }}
</template>

<script>
import formatters from '@/utils/formatters';
export default {
    name: 'ModalProcessamentoRastreabilidadeEmMassaPlanilha',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        dados: {
            type: Array,
            required: true
        },
        temError: {
            type: Boolean,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        },
        modalAlerta: {
            type: Boolean,
            required: false
        }
    },

    data() {
        return {
            paginaAtual: 1,
            pageCount: 5,
            alertDados: {
                type: '',
                msg: ''
            }
        };
    },

    watch: {
        show: function () {
            if (!this.show) return;
            this.resetModal();

            if (this.temError) {
                this.alertDados = {
                    type: 'error',
                    msg: this.getMensagemInconsistenciasTraduzida()
                };
            } else {
                this.alertDados = {
                    type: 'success',
                    msg: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.camposPreenchidosSucesso'
                    )
                };
            }
        },
        modalAlerta: function () {
            if (this.temError) {
                this.alertDados = {
                    type: 'error',
                    msg: this.getMensagemInconsistenciasTraduzida()
                };
            } else {
                this.alertDados = {
                    type: 'success',
                    msg: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.camposPreenchidosSucesso'
                    )
                };
            }
        }
    },

    computed: {
        dadosPaginado() {
            const inicio = (this.paginaAtual - 1) * this.pageCount;
            const fim = inicio + this.pageCount;

            return this.dados.slice(inicio, fim);
        },
        somarTonelada() {
            let soma = 0;
            this.dados.forEach(item => {
                const valor = item['Volume'];
                const numero = parseFloat(valor);
                if (!isNaN(numero)) {
                    soma += numero;
                }
            });
            return soma;
        }
    },

    methods: {
        resetModal() {
            this.paginaAtual = 1;
            this.alertDados = {
                type: '',
                msg: ''
            };
            this.modalAlerta = false;
        },
        mudarPagina(currentPage) {
            this.paginaAtual = currentPage;
        },
        formatarCpfCnpj(valor) {
            if (
                /^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(valor) ||
                /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/.test(valor)
            ) {
                return valor;
            } else {
                return formatters.numeralStringFormatTocpfCnpj(
                    valor.replace(/\D/g, '')
                );
            }
        },

        fecharModal() {
            try {
                this.$messageBox
                    .confirm(
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.temCerteza'
                        ),
                        this.$t('mensagens.comuns.aviso'),
                        {
                            confirmButtonText: this.$t('mensagens.comuns.sim'),
                            cancelButtonText: this.$t(
                                'mensagens.relatorioRastreabilidade.cadastro.permanecer'
                            ),
                            type: 'warning'
                        }
                    )
                    .then(() => {
                        this.$emit('voltar');
                    })
                    .catch(() => {});
            } catch (erro) {}
        },
        async analisarImoveis() {
            this.$emit('analisarImoveis');
        },
        formatarTonelada(valor) {
            return formatters.formatNumber(valor, 2);
        },
        formatarAnoCiclo(valor) {
            return Number(parseInt(valor));
        },
        getMensagemInconsistenciasTraduzida() {
            if (this.$i18n._vm.locale === 'en') {
                return (
                    this.dados.length +
                    ' ' +
                    this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.foramIdentificados'
                    ) +
                    ' ' +
                    this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.avisoInconsistencias'
                    )
                );
            }

            return (
                this.$t(
                    'mensagens.relatorioRastreabilidade.cadastro.foramIdentificados'
                ) +
                ' (' +
                this.dados.length +
                ') ' +
                this.$t(
                    'mensagens.relatorioRastreabilidade.cadastro.avisoInconsistencias'
                )
            );
        }
    }
};
</script>

<style lang="scss">
#modal-header-planilha {
    footer {
        display: flex;
        justify-content: space-between;
    }
}
.modal-header-planilha-content {
    .el-dialog__header {
        padding: 20px;
        padding-bottom: 10px;
        background: var(--primary) !important;
        color: var(--white);
        padding-bottom: 12px;
        padding-top: 12px;
    }
    .el-dialog__body {
        padding: 20px 20px 30px 20px;
        word-break: break-word;
    }
    .el-dialog__headerbtn {
        top: 10px;
    }
    .el-dialog__headerbtn:hover .el-icon-close {
        color: #ffffff;
    }
    .modal-analise-elegibilidade--header {
        display: flex;
        align-items: center;
    }
    .container-header-table__infor {
        margin-bottom: 18px;

        .el-alert__title {
            color: #3b3b3b !important;
        }
    }
    .container-header-table {
        h4 {
            margin-bottom: 16px;
        }

        .el-table {
            border-top-right-radius: 11px;
            border-top-left-radius: 11px;
            min-height: 140px;

            thead.has-gutter {
                th.el-table__cell {
                    background-color: #fbfbfb;
                }
            }

            .descricao-item-tabela {
                margin-left: 55px;
                margin-right: 55px;
            }
            .el-table .cell .el-checkbox__inner {
                padding: 0px;
            }
        }
    }
    .container-header-pagination {
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .spans-paginacao {
            display: flex;
            gap: 21px;
            color: #183b57;
            font-weight: bold;
        }
    }

    .btn-opcao {
        .el-button {
            min-width: 153px;
        }
    }
}
</style>
